import Vue from "vue";
import App from "./App.vue";
import api from "./http";
import "./plugins/bootstrap-vue";
import "./plugins/loading-overlay";
import router from "./router";
import store from "./store";
import VueCryptojs from 'vue-cryptojs';

Vue.prototype.$http = api;
Vue.config.productionTip = false;

Vue.use(VueCryptojs)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
